/* R731: presentation only. Dialogue never gates combat, XP, or settlement. */
(function () {
  'use strict';
  if (window.HOHEmber) return;
  var ID = 'c844a24c-8972-430c-b55d-445e9721f35d';
  var KEY = 'ff:' + ID;
  var LINES = {
    arrival: ["Hi! I’m Ember. I’ve got your back. And your armor.", "Room for one more? You could use some backup.", "You lead. I’ll keep an eye on you and that armor."],
    retry: ["Back on your feet? Good. So am I.", "Still here, aren’t we? That’s a start.", "There you are! I was hoping you’d come back."],
    craft: ["Here. I made this with you in mind.", "A little something I’ve been working on.", "Fresh from the forge. Careful, it’s still warm!"],
    heal: ["Hold still. I’m not losing you today.", "Breathe. I’ve put worse back together.", "I’m rather fond of you in one piece, you know."],
    boss: ["Stay close. I’ll watch your back.", "Well! I was hoping for a chat, but hammer it is.", "You find an opening. I’ll be the loud, distracting one."],
    round20: ["Oh, look at you! That was brilliant!", "That deserves a hug. After we’re somewhere less pointy.", "Well fought. I’m with you until this is over."],
    early_end: ["Rest now. We’ll find our way through.", "Come on. Sit with me a minute. You’ve earned a breather.", "You rest. I’ll take a look at that armor."],
    death: ["Don’t blame yourself. I’m glad I was here with you.", "I promised I’d see you through… I’m sorry.", "Turns out… I can’t fix everything."],
    reunion: ["Remember me? I told you I’d see you in the Hall.", "Well, look at you. Room for an old friend?", "Oh, it’s you! Come here. I’ve missed that face."],
    farewell: ["You’re ready to lead. I’ll see you in the Hall."]
  };
  var queue = [], active = null, attempts = {}, deadRuns = {}, fightRounds = {};
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function isMentor(h) { return !!h && h.key === 'run:mentor:ember' && h.ember_mentor === true; }
  function spaceHtml(run, list, mine) {
    return mine && run && (run.engine_ver | 0) >= 89 && (list || []).some(isMentor)
      ? '<div class="hoh-ember-space" aria-hidden="true"></div>' : '';
  }
  function styles() {
    if (document.getElementById('hohEmberStyle')) return;
    var s = document.createElement('style'); s.id = 'hohEmberStyle';
    s.textContent = '.hoh-ember-voice{position:fixed;box-sizing:border-box;width:max-content;max-width:min(248px,calc(100vw - 24px));padding:11px 14px;border:1px solid transparent;border-radius:12px;background:linear-gradient(#15101e,#15101e) padding-box,linear-gradient(120deg,#ef94ff99,#b3f5ee99) border-box;color:#f1e9f2;box-shadow:0 3px 16px #0006,0 0 12px #ef94ff14;z-index:2147482000;pointer-events:none;font:italic 14px/1.5 Georgia,serif;text-align:center;animation:hohEmberVoiceIn .22s ease-out}.hoh-ember-voice:after{content:"";position:absolute;left:var(--tip,50%);bottom:-5px;width:8px;height:8px;transform:rotate(45deg);background:#15101e;border-right:1px solid #b3f5ee80;border-bottom:1px solid #b3f5ee80}.hoh-ember-voice.below:after{bottom:auto;top:-5px;transform:rotate(225deg)}.hoh-ember-arriving{animation:hohEmberArrival .65s cubic-bezier(.2,.7,.2,1)!important}.hoh-ember-voice-name{display:block;margin-bottom:3px;font:600 10px/1.2 Georgia,serif;letter-spacing:.1em;color:#ead0ed}.hoh-ember-retained{display:block;margin-top:5px;font:11px/1.4 system-ui,sans-serif;color:#b3f5ee}@keyframes hohEmberArrival{from{opacity:0;transform:translateY(14px);filter:brightness(1.18)}to{opacity:1;transform:translateY(0);filter:brightness(1)}}@keyframes hohEmberVoiceIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}@media(prefers-reduced-motion:reduce){.hoh-ember-arriving,.hoh-ember-voice{animation:none!important}}';
    s.textContent += '.hoh-ember-voice.beside:after{left:-5px;top:calc(50% - 4px);bottom:auto;transform:rotate(135deg)}';
    s.textContent += '.hoh-ember-voice-portrait{display:none}.hoh-ember-voice.compact{max-width:none;padding:5px 9px 5px 50px;font-size:13px;line-height:17px;min-height:54px;box-shadow:none}.hoh-ember-voice.compact:after{display:none}.hoh-ember-voice.compact .hoh-ember-voice-name{font-size:9px;line-height:11px;margin-bottom:1px}.hoh-ember-voice.compact .hoh-ember-voice-portrait{display:block;position:absolute;left:8px;top:9px;width:34px;height:34px;object-fit:cover;border-radius:7px;border:1px solid #ef94ff80}';
    s.textContent += '.hoh-ember-space{display:none}@media(max-width:900px){.hoc-fan>.hoh-ember-space,.hoc-mfan>.hoh-ember-space{display:block;flex:0 0 100%;height:116px;max-width:none;padding:0;margin:0;pointer-events:none}}';
    document.head.appendChild(s);
  }
  function safeCurrent(o) {
    try { return String(window.HOHContractData.email() || '') === o.account &&
      (!o.current || o.current()) && (!deadRuns[o.family] || o.trigger === 'death' || o.trigger === 'reunion'); }
    catch (_) { return false; }
  }
  function anchorOf(o) { try { return typeof o.anchor === 'function' ? o.anchor() : o.anchor; } catch (_) { return null; } }
  function visibleAnchor(o) {
    var el = anchorOf(o); if (!el || !el.isConnected) return null;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight ? el : null;
  }
  function finish() {
    if (!active) return;
    clearTimeout(active.timer); clearTimeout(active.track);
    if (active.el) active.el.remove();
    if (active.slot) active.slot.classList.remove('has-voice');
    active = null; pump();
  }
  function paint(o, text, level) {
    var anchor = visibleAnchor(o); if (!anchor || !safeCurrent(o)) return;
    styles(); var el = document.createElement('div'); el.className = 'hoh-ember-voice';
    el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    var name = document.createElement('span'); name.className = 'hoh-ember-voice-name'; name.textContent = 'EMBER';
    el.appendChild(name); el.appendChild(document.createTextNode(text));
    var art = anchor.querySelector('img');
    if (art) { var portrait = document.createElement('img'); portrait.className = 'hoh-ember-voice-portrait'; portrait.alt = ''; portrait.src = art.currentSrc || art.src; el.appendChild(portrait); }
    if (o.trigger === 'reunion' && level >= 30) {
      var retained = document.createElement('span'); retained.className = 'hoh-ember-retained';
      retained.textContent = 'Level ' + level + ' · Your progress stayed with her'; el.appendChild(retained);
    }
    document.body.appendChild(el); active.el = el;
    var fan = o.trigger !== 'reunion' && anchor.closest('.hoc-fan,.hoc-mfan');
    function place() {
      if (!active || active.o !== o) return;
      var a = visibleAnchor(o); if (!a || !safeCurrent(o)) { finish(); return; }
      var panel = a.closest('.hoc-live-battle');
      var slot = panel && panel.querySelector('#hocDialogueSlot');
      if (active.slot && active.slot !== slot) active.slot.classList.remove('has-voice');
      if (slot) slot.classList.add('has-voice');
      active.slot = slot;
      var compact = !!slot && slot.getBoundingClientRect().height > 0;
      el.classList.toggle('compact', compact);
      if (compact) {
        var sr = slot.getBoundingClientRect();
        el.style.width = sr.width + 'px'; el.style.left = sr.left + 'px'; el.style.top = sr.top + 'px';
        active.track = setTimeout(place, 120); return;
      }
      el.style.width = '';
      var r = a.getBoundingClientRect(), w = el.offsetWidth, h = el.offsetHeight;
      var left = Math.max(12, Math.min(window.innerWidth - w - 12, r.left + r.width / 2 - w / 2));
      var space = fan && fan.querySelector('.hoh-ember-space');
      var reserved = space && space.getBoundingClientRect().height > 0;
      var beside = !!fan && !reserved && r.right + w + 24 < window.innerWidth;
      var below = !!fan && !beside || r.top < h + 24;
      el.classList.toggle('below', below);
      if (beside) left = r.right + 12;
      el.style.left = left + 'px';
      var bottom = reserved ? space.getBoundingClientRect().top : r.bottom;
      el.style.top = Math.max(12, Math.min(window.innerHeight - h - 12, beside ? r.top + r.height / 2 - h / 2 : below ? bottom + 12 : r.top - h - 12)) + 'px';
      el.classList.toggle('beside', beside);
      el.style.setProperty('--tip', Math.max(12, Math.min(w - 20, r.left + r.width / 2 - left)) + 'px');
      active.track = setTimeout(place, 120);
    }
    place();
    if (active && active.o === o) active.timer = setTimeout(finish, o.trigger === 'death' ? 5400 : 4600);
  }
  function pump() {
    if (active) return;
    var o = queue.shift(); if (!o) return;
    if (!safeCurrent(o) || !visibleAnchor(o) || (o.round && fightRounds[o.family] !== o.round)) {
      // An unshown line has not claimed its server variant. A later genuine
      // trigger may try again; never narrate an earlier fight from the queue.
      delete attempts[o.attemptKey];
      pump(); return;
    }
    active = { o: o };
    var D = window.HOHContractData;
    if (!D || !D.emberLine) { finish(); return; }
    // A timeout/error drops dialogue only. Never hold the combat tape.
    D.emberLine(o.run && o.run.id, o.trigger, o.characterId).then(function (r) {
      if (!active || active.o !== o) return;
      if (!r || !r.ok || !LINES[r.trigger] || !LINES[r.trigger][r.variant]) {
        // An earlier pull before Round20 must not suppress the real reunion.
        if (o.trigger === 'reunion') delete attempts[o.attemptKey];
        finish(); return;
      }
      paint(o, LINES[r.trigger][r.variant], r.level);
      if (active && !active.el) finish();
    }).catch(function () {
      if (o.trigger === 'reunion') delete attempts[o.attemptKey];
      if (active && active.o === o) finish();
    });
  }
  function say(o) {
    if (!o || !LINES[o.trigger]) return;
    o.family = String((o.run && o.run.seed) || 'pack');
    o.round = fightRounds[o.family] || 0;
    var account = window.HOHContractData && window.HOHContractData.email();
    o.account = String(account || '');
    var key = String(account || '') + ':' + o.family + ':' + o.trigger;
    o.attemptKey = key;
    if (attempts[key] || !safeCurrent(o) || !visibleAnchor(o)) return;
    attempts[key] = true;
    if (o.trigger === 'death') {
      queue = queue.filter(function (q) { return q.family !== o.family; });
      queue.unshift(o);
      if (active && active.o.family === o.family) finish(); else pump();
    } else { queue.push(o); pump(); }
  }
  function arrive(run, heroes, anchor, current) {
    if (!run || (run.engine_ver | 0) < 89 || !(heroes || []).some(isMentor)) return;
    var el = typeof anchor === 'function' ? anchor() : anchor;
    if (el && !attempts['entry:' + run.seed]) {
      attempts['entry:' + run.seed] = true; styles(); el.classList.add('hoh-ember-arriving');
      setTimeout(function () { el.classList.remove('hoh-ember-arriving'); }, 700);
      if (!reduced() && window.hohFx) {
        var r = el.getBoundingClientRect();
        try { window.hohFx.emit('rise', {x:r.left+r.width/2,y:r.bottom,spread:r.width*.8,n:12,color:'#e8c674',hold:700}); } catch (_) {}
      }
    }
    say({run:run,trigger:'arrival',anchor:anchor,current:current});
  }
  function event(run, heroes, x, anchor, current, fast) {
    if (!run || (run.engine_ver | 0) < 89 || !x) return;
    var seat = -1; (heroes || []).some(function (h,i) { if (isMentor(h)) { seat=i; return true; } return false; });
    if (seat < 0) return;
    var family = String(run.seed), trigger = '';
    if (x.e === 'fight_start') fightRounds[family] = x.n | 0;
    if (x.e === 'fight_start' && (x.n | 0) > 0 && (x.n | 0) % 5 === 0) trigger = 'boss';
    if (x.s === 'A' && (x.i | 0) === seat) {
      if (x.e === 'cardgen') trigger = 'craft';
      if (x.e === 'ability_result' && x.op === 'heal' && x.n > 0 && x.before <= 30) trigger = 'heal';
      if (x.e === 'fell') { deadRuns[family] = true; trigger = 'death'; }
    }
    if (x.e === 'fight_end' && (x.n | 0) === 20 && x.cleared === 1) trigger = 'round20';
    if (trigger && !fast) say({run:run,trigger:trigger,anchor:anchor,current:current});
  }
  function end(run, heroes, cleared, anchor, current) {
    if ((heroes || []).some(isMentor) && !deadRuns[String(run && run.seed)])
      say({run:run,trigger:cleared >= 20 ? 'farewell' : 'early_end',anchor:anchor,current:current});
  }
  window.HOHEmber = { ID:ID, KEY:KEY, lines:LINES, isMentor:isMentor, spaceHtml:spaceHtml, say:say, arrive:arrive, event:event, end:end };
  styles();
}());
